document.addEventListener("DOMContentLoaded", () => {

  // Weglot language
  const langMap = {
    "sr-latn": "sr",
    "sr": "sr",
    "en": "en",
    "en-us": "en"
  };

  const currentLang = (typeof Weglot !== "undefined" ? Weglot.getCurrentLang() : "sr") || "sr";

  // Login error translation
  const loginErrorsBox = document.querySelector(".custom-login-errors");

  const loginTranslations = {
    en: "Incorrect email or password.",
    sr: "E-mail ili lozinka su pogrešni."
  };

  // Function to apply translations
  function applyLoginErrorTranslation(lang) {
    if (!loginErrorsBox) return;

    const safeLang = langMap[lang.toLowerCase()] || "en";

    const html = loginErrorsBox.innerHTML.trim();
    if (html === "") return;

    loginErrorsBox.innerHTML = `
      <ul class="errors">
        <li>${loginTranslations[safeLang]}</li>
      </ul>
    `;
  }

  applyLoginErrorTranslation(currentLang);

  // Reset Password error translation
  const resetErrorsBox = document.querySelector(".custom-reset-errors");

  const resetTranslations = {
    en: "No account was found with this email.",
    sr: "Nije pronađen nijedan nalog s tim email-om."
  };

  // Function to apply translations
  function applyResetErrorTranslation(lang) {
    if (!resetErrorsBox) return;

    const safeLang = langMap[lang.toLowerCase()] || "en";
    const hasErrors = resetErrorsBox.innerText.trim() !== "";

    if (!hasErrors) return;

    resetErrorsBox.innerHTML = `
      <ul class="errors">
        <li>${resetTranslations[safeLang]}</li>
      </ul>
    `;
  }

  applyResetErrorTranslation(currentLang);

  if (typeof Weglot !== "undefined") {
    Weglot.on("languageChanged", (lang) => {
      applyLoginErrorTranslation(lang);
      applyResetErrorTranslation(lang);
    });
  }
});
